"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.throttle = void 0;
var wait_1 = require("./wait");
/**
 * Throttle an asynchronous function so it is only invoked once during the period,
 * and never invoked a second time while a previous invocation has not yet completed.
 * If the throttled function is called multiple times within the period, all those
 * calls will receive the result of the next invocation.
 * @param period The minimum time to wait since the last invocation before allowing
 *               the wrapped function to be invoked again.
 */
function throttle(fn, period) {
    if (period === void 0) { period = 1000; }
    var timeout;
    var inProgress;
    var next;
    return function () {
        var context = this;
        if (next) {
            return next;
        }
        if (inProgress || timeout) {
            return next = waitInvokeNext()
                .then(function (result) { next = undefined; return result; }, function (err) { next = undefined; throw err; });
        }
        return invokeNow();
        function waitInvokeNext() {
            return __awaiter(this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!timeout) return [3 /*break*/, 2];
                            // wait till the previous throttle period has passed
                            return [4 /*yield*/, timeout];
                        case 1:
                            // wait till the previous throttle period has passed
                            _b.sent();
                            _b.label = 2;
                        case 2:
                            if (!inProgress) return [3 /*break*/, 6];
                            _b.label = 3;
                        case 3:
                            _b.trys.push([3, 5, , 6]);
                            // ensure the previous invocation is complete
                            return [4 /*yield*/, inProgress];
                        case 4:
                            // ensure the previous invocation is complete
                            _b.sent();
                            return [3 /*break*/, 6];
                        case 5:
                            _a = _b.sent();
                            return [3 /*break*/, 6];
                        case 6: return [2 /*return*/, invokeNow()];
                    }
                });
            });
        }
        function invokeNow() {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    // set the throttling timeout
                    timeout = (0, wait_1.wait)(period)
                        .then(function () { timeout = undefined; });
                    inProgress = fn.apply(context)
                        .then(function (result) { inProgress = undefined; return result; }, function (err) { inProgress = undefined; throw err; });
                    return [2 /*return*/, inProgress];
                });
            });
        }
    };
}
exports.throttle = throttle;
//# sourceMappingURL=throttle.js.map